<template>
    <div class="card" :data-bot="isCustomizable ? 'dashboard__card--is-customizable' : false">
        <!-- HEADER -->
        <header v-if="showHeader" class="card-header" :class="{ 'header-corp': type == 'corp' }">
            <div class="typographies-heading-h3"><slot name="title"></slot></div>
            <ul class="card-actions">
                <slot name="actions"></slot>
                <li class="dinlineb">
                    <CompassMenu
                        ref="refMenuActions"
                        trigger="hover"
                        placement="bottom-end"
                        customClass="layout-card__dropdown"
                    >
                        <CompassIconButton icon="action" class="layout-card__dropdown-icon" />
                        <template #dropdown>
                            <CompassDropdownOption
                                v-if="canRefresh"
                                :label="$t.__('common.actions.refresh')"
                                data-bot="dashboard__card-menu--refresh"
                                @click="$emit('refresh-card')"
                            />
                            <CompassDropdownOption
                                v-if="isCustomizable"
                                :label="$t.__('common.actions.configure')"
                                data-bot="dashboard__card-menu--edit"
                                @click="$emit('edit-card')"
                            />
                            <CompassDropdownOption
                                :label="$t.__('common.labels.hide')"
                                data-bot="dashboard__card-menu--hide"
                                @click="$emit('hide-card')"
                            />
                        </template>
                    </CompassMenu>
                </li>
            </ul>
        </header>

        <!-- BODY -->
        <div class="card-body prelative">
            <div v-if="loading === true" class="card-loader pabsolute">
                <preloader :display="true" />
            </div>
            <slot v-if="!error" name="content">
                <div
                    class="my-0 mx-auto flex-column hp-10 ai-center jc-center"
                    style="width: 170px"
                >
                    <img :src="placeholderImg" alt="" width="120" />
                    <div class="mt-3 gray-60 acenter">{{ placeholderText }}</div>
                </div>
            </slot>
            <div v-else class="acenter">
                <div class="alert alert-danger" v-html="error"></div>
            </div>
        </div>

        <!-- FOOTER -->
        <div class="card-footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        Preloader,
    },

    props: {
        type: {
            type: String,
            required: false,
            default: 'staff',
        },
        loading: {
            type: Boolean,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        placeholderImg: {
            type: String,
            required: false,
            default: '/ressources/logged/img/dashboard/no-result-illustration.svg',
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
        isCustomizable: {
            type: Boolean,
            default: false,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        canRefresh: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['refresh-card', 'edit-card', 'hide-card'],
    computed: {
        placeholderText() {
            return this.placeholder !== ''
                ? this.placeholder
                : this.$l10n.__('Aucune donnée à afficher');
        },
    },
};
</script>

<style lang="scss" scoped>
.layout-card {
    &__dropdown {
        &-icon {
            cursor: pointer;
        }
    }
}
</style>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.card-loader {
    top: 0;
    left: 0;
    background: white;
    width: 100%;
    height: 100%;

    .preloader {
        background: white;
    }
}

.card {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    font-size: $font-size;

    ul,
    p {
        margin: 0;
    }

    &:not(.card-report) a {
        color: $gray-100;
    }

    .card-header {
        display: flex;
        padding: var(--spacing-3);
        align-items: center;
        color: $gray-100;
        cursor: move;
        border-bottom: 1px solid $border-color;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        h2 {
            margin: 0;
            font-size: $big-font-size;
        }

        &.header-corp {
            background: $gray-05;
            color: $gray-100;
        }
        .card-actions {
            display: flex;
            align-items: center;
            flex-grow: 1;
            justify-content: end;
            gap: var(--spacing-1);
        }
    }

    &.card-pinned .card-header {
        cursor: default;
    }

    .card-body {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: var(--spacing-3);
        overflow: hidden;

        h3 {
            margin-top: 0;
        }
    }

    .card-footer {
        text-align: right;

        span {
            color: $gray-60;
            font-size: 12px;
        }
    }

    &.card-task .card-body {
        flex-direction: row;
    }
}

.resize-handle {
    display: none !important;
}

.vue-grid-item {
    background-color: $white;
    border: 1px solid $border-color;
    border-radius: var(--spacing-0);
}

.vue-grid-item.vue-grid-placeholder {
    background: $lightgrey !important;
    opacity: 1 !important;
}
</style>
